import StyleCommand from 'commands/styleCommand';
import utils from 'utils/utils';

function LetterSpacingCommand() {
    StyleCommand.call(this, 'span', 'letter-spacing');
}

LetterSpacingCommand.prototype = Object.create(StyleCommand.prototype);

LetterSpacingCommand.prototype.refresh = function (editor, elementPath) {
    StyleCommand.prototype.refresh.call(this, editor, elementPath);
    if (/px/.test(this.state)) {
        var parentBlock = utils.getBlockParent(elementPath);
        var baseSize = getComputedStyle(parentBlock.$)['font-size'];
        var emSize = Number((parseFloat(this.state) / parseFloat(baseSize)).toFixed(2));
        this.setState(emSize + 'em');
    }
};

export default LetterSpacingCommand;
